import { useState } from "react";
import { getTicketErrorMessage } from "entities/support-ticket";
import type {
  CreateTicketRequest,
  CreateTicketResponse,
} from "entities/support-ticket";
import { useCreateTicketMutation } from "../api/createTicketApi";
import {
  TicketErrors,
  TicketField,
  hasTicketErrors,
  validateTicket,
} from "./validateTicket";

const EMPTY_VALUES: CreateTicketRequest = { subject: "", body: "" };
const NO_ERRORS: TicketErrors = {};

export const useCreateTicket = (
  onCreated?: (ticket: CreateTicketResponse) => void,
) => {
  const [values, setValues] = useState(EMPTY_VALUES);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [createTicket, { isLoading, error, reset }] = useCreateTicketMutation();

  const errors = validateTicket(values);

  const setValue = (field: TicketField, value: string) => {
    setValues((prev) => ({ ...prev, [field]: value }));
    reset();
  };

  const submit = async () => {
    setIsSubmitted(true);
    if (hasTicketErrors(errors)) return;
    const result = await createTicket({
      subject: values.subject.trim(),
      body: values.body.trim(),
    });
    if (result.data) onCreated?.(result.data);
  };

  return {
    values,
    setValue,
    // Ошибки полей показываются только после первой попытки отправки.
    errors: isSubmitted ? errors : NO_ERRORS,
    serverError: getTicketErrorMessage(error),
    submit,
    isSubmitting: isLoading,
  };
};
